<div id="divNavigation" class="row border-bottom">
	<nav class="navbar navbar-static-top" role="navigation" style="margin-bottom: 0">
		<div>
			<a class="navbar-minimalize minimalize-styl-2 btn btn-primary" (click)="tabclick($event)" href="#"><i class="fa fa-bars"></i> </a>

			<form class="navbar-form-custom" role="search" name="searchform" id="searchform">
				<div class="form-group">
					<h2 style="align-content: center; margin-top: 15px; width: 450%; width: max-content">
						<button
							pTooltip="Click to add to favorites"
							tooltipPosition="right"
							[disabled]="FavoriteLoading == true"
							style="border: 0px; background: transparent; padding: 0px"
							*ngIf="CanFavorite == true && PageFavorited == false"
							(click)="onFavorite()"
						>
							<i class="fa fa-star-o" aria-hidden="true"></i>
						</button>
						<button
							pTooltip="Click to remove from favorites"
							tooltipPosition="right"
							[disabled]="FavoriteLoading == true"
							style="border: 0px; background: transparent; padding: 0px"
							*ngIf="CanFavorite == true && PageFavorited == true"
							(click)="onUnFavorite()"
						>
							<i class="fa fa-star" aria-hidden="true"></i>
						</button>
						{{ Title }}
					</h2>
				</div>
			</form>
		</div>

		<!--Broadcast Alert Messages-->
		<div style="display: flex; justify-content: flex-end">
			<div style="width: 100%">
				<caass-broadcast-messages></caass-broadcast-messages>
			</div>

			<ul class="nav navbar-top-links navbar-right" style="min-width: 280px; display: flex; align-items: center">
				<!-- <li>
          <a>
            <i class="material-icons" class='icon'>

              <img src=" assets/img/notify1.png" width="30" height="30">
              <br>
              <div style="font-size:xx-small;
                  position: absolute;
                  top: 5px;
                  left: 5px;">
                <button style="margin:15px; font-size: 10px; background-color: red ;color:white  ; border-radius: 15%;  "
                  class="btn-group-vertical">3</button>
              </div>
            </i>
          </a>
        </li>



        <li>
          <a *ngIf='!OpenVerify' (click)="verifyAttendance();" href='javascript:void(0);' (mouseover)="showVerifyAttendance()"
            (mouseout)="noshowVerifyAttendance()">
            <span *ngIf="showVerify">Verify Attendance!</span>
            <i class="material-icons" class='icon'>

              <img src=" assets/img/verifyAttendance.png" width="30" height="30">
              <br>
              <div style="font-size:xx-small;
      position: absolute;
      top: 5px;
      left: 5px;">
                <button style="margin:15px; font-size: 10px; background-color: red ;color:white  ; border-radius: 15%;  "
                  class="
  btn-group-vertical">{{numberOfNotification}}</button></div>
            </i>
          </a>
        </li> -->

				<li style="min-width: 90px" *ngIf="SBMInboxCount == 0 && ReportInboxCount == 0" [pTooltip]="UserTooltip">
					<span class="m-r-sm text-muted welcome-message">Welcome {{ username }}.</span>
				</li>
				<li style="min-width: 90px" *ngIf="SBMInboxCount > 0 || ReportInboxCount > 0" [pTooltip]="UserTooltip">
					<div>
						<span class="m-r-sm text-muted welcome-message">Welcome {{ username }}.</span>

						<div *ngIf="SBMInboxCount > 0" class="InboxGrid" (click)="onGoToSBMInbox()">
							<i style="font-size: 20px" class="fa fa-inbox" aria-hidden="true"></i>
							<div class="alert alert-danger InboxCount">
								{{ SBMInboxCount }}
							</div>
						</div>

						<div *ngIf="ReportInboxCount > 0" class="InboxGrid" (click)="onGoToReportInbox()">
							<i style="font-size: 20px" class="fa fa-table" aria-hidden="true"></i>
							<div class="alert alert-danger InboxCount">
								{{ ReportInboxCount }}
							</div>
						</div>
					</div>
				</li>

				<li *ngIf="user?.userID != 0" [pTooltip]="UserTooltip">
					<a (click)="onSettings()" href="javascript:void(0);">
						<i class="fa fa-cog" aria-hidden="true"></i>
					</a>
				</li>

				<li style="min-width: 95px" [pTooltip]="UserTooltip">
					<a (click)="logout()" href="javascript:void(0);"> <i class="fa fa-sign-out"></i> Log out </a>
				</li>
			</ul>
		</div>
	</nav>

	<div *ngIf="attendanceVerify">
		<div class="row">
			<div class="col-lg-12">
				<div class="ibox float-e-margins">
					<div class="ibox-content">
						<div class="panel panel-default">
							<div class="panel-heading">
								<h1>Attendance Verification</h1>
								<h5>Please verify that the students were present in your respective classes !</h5>
								<div (mouseover)="todayList()" (mouseout)="notodayList()">
									<label
										>Show Today's <input type="checkbox" name="classdate" class="form-control" (change)="onCheckboxChange($event)"
									/></label>
								</div>
								<span *ngIf="showtodayList" style="color: chocolate">Check the box for today's list of attendance verification!</span>
								<div *ngIf="showToday" class="alert alert-info box-msg" role="alert">
									<strong>Please wait, loading today's list of student to be verified..!</strong>
								</div>

								<div *ngIf="showAll" class="alert alert-info box-msg" role="alert">
									<strong>Please wait, loading all student to be verified..!</strong>
								</div>
								<div *ngIf="OpenVerify" class="alert alert-danger box-msg" role="alert">
									<strong>There are no Students to Verify</strong>

									<button type="button" class="btn btn-danger" (click)="cancelVerificationWindow()">Close</button>
								</div>
								<div id="searchoption" class="panel-collapse" *ngIf="!OpenVerify">
									<div class="panel-body">
										<div class="row">
											<div class="col-lg-12">
												<div class="ibox float-e-margins">
													<div class="ibox-content">
														<div class="panel panel-default">
															<div class="panel-heading">
																<h5 class="panel-title">
																	<a
																		data-toggle="collapse"
																		href="javascript:void(0);"
																		data-parent="#accordion"
																		data-target="#searchoption"
																	>
																		<strong>Students for attendance verification. </strong></a
																	>
																</h5>
															</div>
															<div id="searchoption" class="panel-collapse">
																<div class="panel-body">
																	<div ngIF="showActionTable">
																		<table
																			class="table table-striped table-bordered dataTable"
																			role="grid"
																			style="width: 100%"
																		>
																			<thead>
																				<tr role="row">
																					<th>Student Name</th>
																					<th>Student ID</th>
																					<th>Date of Attendance</th>
																					<th>Period</th>
																					<th>Course</th>

																					<th>Attended?</th>
																				</tr>
																			</thead>
																			<tbody>
																				<tr *ngFor="let student of pagedItems">
																					<td>
																						{{ student.FirstName }}
																						{{ student.LastName }}
																					</td>
																					<td>
																						{{ student.StudentID }}
																					</td>

																					<td>
																						{{ student.EntryDate | date : "MM/dd/yyyy" }}
																					</td>
																					<td>
																						{{ student.PeriodNo }}
																					</td>
																					<td>
																						{{ student.CourseCD }}
																					</td>

																					<td>
																						<div>
																							<span style="display: inline-block; width: 55px"></span>
																							<button
																								type="button"
																								class="btn"
																								(click)="
																									setBColor(
																										$event,
																										student.StudentID,
																										student.ClassAttendanceStudentID
																									)
																								"
																								id="pButton"
																								[ngStyle]="{
																									'background-color': student.pbuttonColor
																								}"
																							>
																								Yes
																							</button>

																							<span style="display: inline-block; width: 8px"></span>
																							<button
																								type="button"
																								class="btn"
																								(click)="
																									setBColor(
																										$event,
																										student.StudentID,
																										student.ClassAttendanceStudentID
																									)
																								"
																								id="aButton"
																								[ngStyle]="{
																									'background-color': student.abuttonColor
																								}"
																							>
																								No
																							</button>
																						</div>
																					</td>
																				</tr>
																			</tbody>
																		</table>
																		<div align="right">
																			<ul *ngIf="pager.pages && pager.pages.length" class="pagination">
																				<li
																					[ngClass]="{
																						disabled: pager.currentPage === 1
																					}"
																				>
																					<a (click)="setPage(1)">First</a>
																				</li>
																				<li
																					[ngClass]="{
																						disabled: pager.currentPage === 1
																					}"
																				>
																					<a (click)="setPage(pager.currentPage - 1)">Previous</a>
																				</li>
																				<li
																					*ngFor="let page of pager.pages"
																					[ngClass]="{
																						active: pager.currentPage === page
																					}"
																				>
																					<a (click)="setPage(page)">{{ page }}</a>
																				</li>
																				<li
																					[ngClass]="{
																						disabled: pager.currentPage === pager.totalPages
																					}"
																				>
																					<a (click)="setPage(pager.currentPage + 1)">Next</a>
																				</li>
																				<li
																					[ngClass]="{
																						disabled: pager.currentPage === pager.totalPages
																					}"
																				>
																					<a (click)="setPage(pager.totalPages)">Last</a>
																				</li>
																				<div class="form-group" align="right">
																					<div *ngIf="savingVerifify" class="alert alert-danger box-msg" role="alert">
																						<strong>Please wait, verification in process...!</strong>
																					</div>
																					<div *ngIf="markPresent" class="alert alert-info box-msg" role="alert">
																						<strong>Student verified as Present.</strong>
																					</div>
																					<div *ngIf="markAbsent" class="alert alert-danger box-msg" role="alert">
																						<strong>Student verified as Absent.</strong>
																					</div>
																					<br />
																				</div>
																			</ul>
																		</div>
																	</div>
																	<div class="col-sm-12 col-md-12 col-lg-8" align="right">
																		<button type="button" class="btn btn-primary" (click)="submitVerification()">
																			Update
																		</button>
																		<button type="button" class="btn btn-danger" (click)="cancelVerification()">
																			Close
																		</button>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
